// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchBidHistoryParams = {
    authToken: string,
    deployment: string,
    itemId: number,
};

export const fetchBidHistory = ({ authToken, deployment, itemId }: FetchBidHistoryParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: `<ITEM-API>spa/bid-history/${itemId}` });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
